import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import LAYOUT from '@/views/layout'
const routes = [
  {
    path: '',
    component: LAYOUT,
    redirect: '/home',
    children: [
      {
        path: '/permission',
        component: () => import(/* webpackChunkName: "permission" */ '../views/permission.vue'),
        name: 'permission',
        meta: { title: '权限', keepAlive: false }
      },
      {
        path: '/home',
        component: Home,
        name: 'home',
        meta: { title: '首页', keepAlive: false }
      },
      {
        path: '/imageAndText',
        component: () => import(/* webpackChunkName: "imageAndText" */ '../views/imageAndText.vue'),
        name: 'imageAndText',
        meta: { title: '图文报告', keepAlive: false }
      },
      {
        path: '/imageBrowsing',
        component: () => import(/* webpackChunkName: "ImageBrowsing" */ '../views/imageBrowsing.vue'),
        name: 'imageBrowsing',
        meta: { title: '影像浏览', keepAlive: false }
      },
      {
        path: '/historyCheck',
        component: () => import(/* webpackChunkName: "HistoryCheck" */ '../views/historyCheck.vue'),
        name: 'historyCheck',
        meta: { title: '历史检查', keepAlive: false }
      },
      {
        path: '/electronicFilm',
        component: () => import(/* webpackChunkName: "ElectronicFilm" */ '../views/electronicFilm.vue'),
        name: 'electronicFilm',
        meta: { title: '电子胶片', keepAlive: false }
      },
      {
        path: '/404',
        component: () => import('@/views/errorPage/404'),
        name: 'Page404',
        meta: { title: 'page404', keepAlive: true }
      },
      {
        path: '/components',
        component: () => import('@/views/components.vue'),
        name: 'Components',
        meta: { title: 'Components', keepAlive: false }
      }
    ]
  },
  { path: '/:path(.*)*', redirect: '/404', hidden: false }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
